// extracted by mini-css-extract-plugin
export default {"userContainer":"user_userContainer__oBL4g","searchBar":"user_searchBar__npUqp","formContainer":"user_formContainer__81EkW","menuItem":"user_menuItem__jrTle"};